import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import Index from '@/components/Index/index'

import School from '@/components/School/index'

import BookIndex from '@/components/Book/index'
import BookOrder from '@/components/Book/order'
import EditAddress from '@/components/Book/address'
import Success from '@/components/Book/success'

import Evaluation from '@/components/Evaluation/index'

import Course from '@/components/Course/index'
import Search from '@/components/Course/search'
import WorkshopDetail from '@/components/CourseDetail/workshop'
import StudioDetail from '@/components/CourseDetail/studio'
import PublicClassDetail from '@/components/CourseDetail/publicClass'

import Lecturer from '@/components/Lecturer/index'
import LecturerDetail from '@/components/Lecturer/detail'
import Recommend from '@/components/Lecturer/recommend'

import Articles from '@/components/Articles/index'
import ArticleDetail from '@/components/Articles/detail'

import Star from '@/components/Star/index'
import ExpDetail from '@/components/Star/expDetail'
import GraduateDetail from '@/components/Star/graduateDetail'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'Index',
      meta: {title: '首页'},
      component: Index,
    },
    {
      path: '/search',
      name: 'Search',
      meta: {title: '搜索'},
      component: Search,
    },
    {
      path: '/book',
      name: 'BookIndex',
      meta: {title: '《奇想·建筑》'},
      component: BookIndex,
    },
    {
      path: '/book/order',
      name: 'BookOrder',
      meta: {title: '订单确认'},
      component: BookOrder
    },
    {
      path: '/book/editaddress',
      name: 'EditAddress',
      meta: {title: '编辑地址'},
      component: EditAddress,
    },
    {
      path: '/book/success',
      meta: {title: '购买成功'},
      component: Success,
    },
    {
      path: '/evaluation',
      meta: {title: '免费评估'},
      component: Evaluation,
    },
    {
      path: '/course',
      meta: {title: '课程'},
      component: Course
    },
    {
      path: '/course/workshop/:id',
      name: 'workshopDetail',
      meta: {title: '课程'},
      component: WorkshopDetail
    },
    {
      path: '/course/studio/:id',
      name: 'studioDetail',
      meta: {title: '课程'},
      component: StudioDetail
    },
    {
      path: '/course/public_class/:id',
      name: 'publicClassDetail',
      meta: {title: '课程'},
      component: PublicClassDetail
    },
    {
      path: '/lecturer',
      name: 'Lecturer',
      meta: {title: '讲师'},
      component: Lecturer
    },
    {
      path: '/lecturer/detail/:id',
      name: 'LecturerDetail',
      meta: {title: '讲师详情'},
      component: LecturerDetail
    },
    {
      path: '/lecturer/recommend',
      meta: {title: '推荐讲师'},
      component: Recommend
    },
    {
      path: '/article',
      meta: {title: '干货'},
      component: Articles
    },
    {
      path: '/article/detail/:id',
      name: 'ArticleDetail',
      meta: {title: '干货详情'},
      component: ArticleDetail
    },
    {
      path: '/school',
      meta: {title: '学院'},
      component: School,
    },
    {
      path: '/achievement',
      meta: {title: '成果'},
      component: Star,
    },
    {
      path: '/achievement/experience/detail/:id',
      name: 'ExpDetail',
      meta: {title: '经验弹'},
      component: ExpDetail,
    },
    {
      path: '/achievement/graduate/detail/:id',
      name: 'GraduateDetail',
      meta: {title: '优秀毕业生'},
      component: GraduateDetail,
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js